import React from 'react';
import { BaseComponent } from 'components/BaseComponent';
import Checkbox from '@material-ui/core/Checkbox/Checkbox';
import Translate from 'components/Translate';

const styles = require('./acceptTerms.css');

export default class AcceptTerms extends BaseComponent {
  render() {
    return (
      <div className={styles.component}>
        <div className='chk-acceptTerms__span'>
          <Checkbox disabled checked value='checkedE' />
          <Translate term='Concordo que li, e compreendi os' />&nbsp;
          <a id='chk-accept-term' href='https://g.eduzz.com/gateway/termosrec' target='_blank'>
            <Translate term='termos de assinatura e cancelamento' />
          </a>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/AcceptTerms/index.tsx